import { render } from "./FunctionsCatalogInputColumn.vue?vue&type=template&id=5b98aaee&scoped=true&ts=true"
import script from "./FunctionsCatalogInputColumn.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogInputColumn.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogInputColumn.vue?vue&type=style&index=0&id=5b98aaee&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b98aaee"]])

export default __exports__